module.exports = __webpack_public_path__ + "img/contingent-image3.5a878f6c.jpg";